<template>
  <div>
    <nav class="navbar is-dark is-fixed-top">
      <div class="container">
        <div class="navbar-brand">
          <router-link to="/" exact class="navbar-item" title="Home">
            <img src="https://admin.cloudprinter.com/img/logo-blue.png">
          </router-link>
        </div>
      </div>
    </nav>

    <section class="section">
      <div class="container">
        <slot/>
      </div>
    </section>

  </div>
</template>

<script>

export default {
  name: 'LayoutOAuth2'
}
</script>
